const metaData = {
    rotatable: true
}

export default metaData
